import * as React from 'react' // we need this to make JSX compile
import { FC } from 'react'
import StarRating from './StarRating'
import { reviewsStrings } from 'common/strings/reviews-strings'
import useWindowSize from './util/useWindowSize'
import imageResize from 'project/image-proxy-web'

type ReviewsSummaryType = {
  textAlign: 'left' | 'center'
  average: number
  totalReviews: number
}

const ReviewsSummary: FC<ReviewsSummaryType> = ({
  average,
  textAlign,
  totalReviews,
}) => {
  const size = useWindowSize()
  return size.isLgOrHigher ? (
    <>
      <div className='d-md-flex mb-10 justify-content-center gap-2 align-items-center'>
        <div
          className={`text-${textAlign} d-flex justify-content-${textAlign}`}
        >
          <StarRating value={5} />
        </div>
        <div className={`text-${textAlign} text-large`}>
          {average} {reviewsStrings.average} {'|'} {totalReviews}{' '}
          {reviewsStrings.reviews}
        </div>
        <div className={`d-flex justify-content-${textAlign}`}>
          <img
            loading='lazy'
            height={22}
            width={128}
            src={imageResize('/images/ratings/reviews-io-dark.svg', 128, 22)}
            alt={'Reviews IO logo'}
            className='d-block'
          />
        </div>
      </div>
    </>
  ) : (
    <>
      <div className='d-flex justify-content-center mb-8 gap-4 align-items-center'>
        <div>
          <div className={`text-${textAlign} text-large`}>
            {average} {reviewsStrings.average}
          </div>
          <div
            className={`text-${textAlign} d-flex justify-content-${textAlign}`}
          >
            <StarRating value={5} />
          </div>
        </div>
        <div className='d-flex flex-column text-center'>
          {totalReviews} {reviewsStrings.reviews}
          <img
            loading='lazy'
            height={22}
            width={128}
            src={imageResize('/images/ratings/reviews-io-dark.svg', 128, 22)}
            alt={'Reviews IO logo'}
            className='d-block'
          />
        </div>
      </div>
    </>
  )
}

export default ReviewsSummary
